import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var BUTTONS_WIDTH = 300;

var BannerInlineStyles = /*#__PURE__*/function () {
  function BannerInlineStyles() {
    _classCallCheck(this, BannerInlineStyles);
  }

  _createClass(BannerInlineStyles, null, [{
    key: "leftSide",
    value: function leftSide(_ref) {
      var type = _ref.layout.type,
          padding = _ref.bodyDesign.padding,
          antiAdBlocker = _ref.customCss.antiAdBlocker,
          individualPrivacyOpen = _ref.individualPrivacyOpen,
          activeAction = _ref.activeAction;
      var style = {
        float: type === "banner" && activeAction !== "history" ? "left" : undefined,
        width: type === "banner" && activeAction !== "history" ? "calc(100% - ".concat(BUTTONS_WIDTH, "px)") : undefined,
        paddingRight: type === "banner" ? 20 : undefined,
        paddingTop: +padding[0],
        paddingBottom: type === "banner" || individualPrivacyOpen ? +padding[2] : 0
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-tb-left",
        style: style
      };
    }
  }, {
    key: "rightSide",
    value: function rightSide(_ref2) {
      var _style;

      var _ref2$layout = _ref2.layout,
          type = _ref2$layout.type,
          dialogMaxWidth = _ref2$layout.dialogMaxWidth,
          _ref2$design = _ref2.design,
          borderWidth = _ref2$design.borderWidth,
          bg = _ref2$design.bg,
          headerDesign = _ref2.headerDesign,
          footerDesign = _ref2.footerDesign,
          padding = _ref2.bodyDesign.padding,
          inheritDialogMaxWidth = _ref2.individualLayout.inheritDialogMaxWidth,
          antiAdBlocker = _ref2.customCss.antiAdBlocker,
          _ref2$renderedHeights = _ref2.renderedHeights,
          headerContainer = _ref2$renderedHeights.headerContainer,
          footerContainer = _ref2$renderedHeights.footerContainer,
          individualPrivacyOpen = _ref2.individualPrivacyOpen;
      var width = type === "dialog" ? +dialogMaxWidth - padding[1] - padding[3] - borderWidth * 2 : BUTTONS_WIDTH;
      var style = (_style = {
        background: bg,
        paddingTop: type === "banner" || individualPrivacyOpen ? +padding[0] : 10,
        paddingBottom: !individualPrivacyOpen ? +padding[2] : 10,
        float: type === "banner" || individualPrivacyOpen ? "right" : undefined,
        maxWidth: width,
        width: width,
        margin: type === "dialog" && individualPrivacyOpen && !inheritDialogMaxWidth ? "0 0 10px 10px" : undefined,
        // position: individualPrivacyOpen ? "sticky" : undefined, This is done by `body.tsx#usePlainCss`
        position: individualPrivacyOpen ? undefined : "sticky"
      }, _defineProperty(_style, individualPrivacyOpen ? "top" : "bottom", individualPrivacyOpen ? +headerContainer + headerDesign.borderWidth : +footerContainer + footerDesign.borderWidth), _defineProperty(_style, "zIndex", 1), _defineProperty(_style, "display", "flex"), _defineProperty(_style, "flexWrap", "wrap"), _style);
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-tb-right",
        style: style
      };
    }
  }]);

  return BannerInlineStyles;
}();

export { BannerInlineStyles };